import styled from '@emotion/styled';
import { css, SerializedStyles, Theme } from '@emotion/react';

import { Global } from '../../styles';

type PlaneBackgroundStyle = 'green' | 'orange';

const getPlaneBackground = (
  theme: Theme,
  style: PlaneBackgroundStyle,
): SerializedStyles =>
  ({
    green: css`
      background-color: ${theme.colors.brand.green40};
    `,
    orange: css`
      background-color: ${theme.colors.brand.orange40};
    `,
  })[style];

const PlaneBackgroundContainer = styled.div<{
  backgroundStyle: PlaneBackgroundStyle;
}>`
  ${Global.layoutContainerContent};

  ${({ theme, backgroundStyle }) => getPlaneBackground(theme, backgroundStyle)};

  margin-top: -1.25rem;
  margin-bottom: -1.75rem;
  overflow: hidden;
  padding-block: 2.5rem;

  ${({ theme }) => theme.mq('md')} {
    margin-bottom: -2.25rem;
  }

  ${({ theme }) => theme.mq('lg')} {
    margin-bottom: -0.75rem;
  }

  ${({ theme }) => theme.mq('xl')} {
    margin-bottom: -0.75rem;
  }
`;

export { PlaneBackgroundContainer };
export type { PlaneBackgroundStyle };
